// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title___7WqJ system_titleXs__NdNAh","reviewsLayout":"styles_reviewsLayout__r1PkC","comments":"styles_comments__5Zoxk","allReviewsBtn":"styles_allReviewsBtn__qIs9J"};